import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';

const INIT_SEARCH = 'sale/INIT_SEARCH';
export const initSearch = createAction(INIT_SEARCH);

const GET_CAR = 'sale/car/GET_CAR';
export const getCar = createAction(GET_CAR, api.getRyvuss);

const CHANGE_VALUE = 'sale/car/CHANGE_VALUE';
export const chageValue = createAction(CHANGE_VALUE);

const initialState = {
	searchInfo: {},
	title: '',
	order: 'PriceAsc',
	offset: '0',
	size: '400',
	count: 0,
	car: [],
	badge: [],
	badgeGroup: [],
};

export default handleActions(
	{
		[INIT_SEARCH]: (state, action) =>
			produce(state, (draft) => {
				draft.searchInfo = {
					...state.searchInfo,
					...action.payload,
				};
			}),

		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				draft[name] = value;
			}),

		...pender({
			type: GET_CAR,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { Nodes: nav } = data.iNav;

					let car = [];
					if (data.SearchResults.length > 0) {
						car = data.SearchResults.map((item, index) => ({
							...item,
							cnt: index,
						}));
					}

					const selectedModel = nav
						.filter((item) => item.Name === 'ModelCarType')[0]
						.Facets.filter((item) => item.IsSelected)[0]
						.Refinements.Nodes.filter((item) => item.Name === 'ModelPath')[0]
						.Facets.filter((item) => item.IsSelected)[0];

					const { Value: title } = selectedModel;
					const badgeGroup = selectedModel.Refinements.Nodes[0].Facets;

					draft.car = car || [];
					draft.count = data.Count;
					draft.title = `${selectedModel.Metadata.ManufacturerName[0]} ${title}`;
					draft.badgeGroup = badgeGroup || [];
				}),
		}),
	},
	initialState,
);
